function cov_12qaa6yyud() {
  var path = "/app/src/components/long-term-content/components/installment-item/index.ts";
  var hash = "30af1c3880e972ffca21a36c2f1fda63a39bd25f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/components/installment-item/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "30af1c3880e972ffca21a36c2f1fda63a39bd25f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_12qaa6yyud = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_12qaa6yyud();
export { InstallmentItem } from './installment-item';